import React, { useEffect, useState } from "react";
import { Table, Typography } from "antd";
import { t } from "i18next";
import Helper from "../../../core/Helper";
import ApiService from "../../../core/service/ApiService";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { useUser } from "../../../core/context/UserContext";

const { Text } = Typography;

export const EntitlementSummaryRow = () => {
    const { queryModel } = useDataGrid();
    const { formatPrice } = useUser();
    const [summary, setSummary] = useState({
        appointmentSummaries: [],
        entitlementSummaries: [],
    });

    useEffect(() => {
        const get = async () => {
            if (!queryModel.filter) return;

            const input = {
                ...queryModel.filter,
                startDate: Helper.Date.beginOfDay(queryModel.filter.startDate),
                endDate: Helper.Date.endOfDay(queryModel.filter.endDate),
            };
            const res = await ApiService.Entitlement.GetEntitlementGridSummary(input);
            if (res.success) setSummary(res.data);
        };
        get();
    }, [queryModel.updateKey]);

    if (!summary?.appointmentSummaries || summary.appointmentSummaries.length === 0) {
        return null;
    }

    return (
        <Table.Summary>
            <Table.Summary.Row style={{ backgroundColor: '#fafafa' }}>

                {/* 1. ETİKET ALANI: İlk 6 kolonu kaplar (Hasta, Tarih, Birim, Kurum, Sorumlu, Durum) */}
                {/* Bu sayede "Genel Toplam" yazısı Fiyat kolonunun hemen soluna yaslanır */}
                <Table.Summary.Cell index={0} colSpan={8} align="right" style={{ backgroundColor: '#fafafa !important' }}>
                    <Text strong style={{ marginRight: 8, fontSize: 13 }}>{t('General Total')}:</Text>
                </Table.Summary.Cell>

                {/* 2. FİYAT (Price Column) - index 1 */}
                <Table.Summary.Cell index={1} align="right">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        {summary.appointmentSummaries.map((s, idx) => (
                            <Text key={idx} type="secondary" style={{ fontSize: 12, display: 'block' }}>
                                {formatPrice(s.totalPrice, { currency: s.currency || 'TRY' })}
                            </Text>
                        ))}
                    </div>
                </Table.Summary.Cell>

                {/* 3. BAKİYE (Balance Column) - index 2 */}
                <Table.Summary.Cell index={2} align="right">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        {summary.appointmentSummaries.map((s, idx) => (
                            <Text
                                key={idx}
                                strong
                                style={{
                                    fontSize: 12,
                                    color: s.total > 0 ? '#cf1322' : '#389e0d', // Borç varsa kırmızı
                                    display: 'block'
                                }}
                            >
                                {formatPrice(s.total, { currency: s.currency || 'TRY' })}
                            </Text>
                        ))}
                    </div>
                </Table.Summary.Cell>

                {/* 4. HAKEDİŞ (Entitlement Column) - index 3 */}
                <Table.Summary.Cell index={3}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        {summary.entitlementSummaries.map((s, idx) => (
                            <Text key={idx} strong style={{ color: '#1890ff', fontSize: 13 }}>
                                {formatPrice(s.totalEntitlement, { currency: s.currency || 'TRY' })}
                            </Text>
                        ))}
                        {summary.entitlementSummaries.length === 0 && <Text disabled>-</Text>}
                    </div>
                </Table.Summary.Cell>

                {/* 5. BOŞLUK: Son 2 kolon (Onay Durumu, Info Butonu) */}
                <Table.Summary.Cell index={4} colSpan={1} />

            </Table.Summary.Row>
        </Table.Summary>
    );
};